var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBateriaIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.2,119.1c-0.3,0.8-0.5,1.7-0.9,2.5c-2.5,5.2-6.7,7.7-12.4,7.7c-11.3,0-22.6,0-34,0c-25.2,0-50.4,0-75.5,0 c-6,0-10.8-3.1-12.7-8.2c-0.5-1.2-0.7-2.6-0.7-3.8c0-23.8,0-47.5,0-71.3c0-6.1,4.8-11.5,10.8-12.2c1-0.1,2.1-0.2,3.1-0.2 c36,0,72.1,0,108.1,0c7.5,0,11.5,2.8,14.1,9.8c0,0.1,0.1,0.1,0.2,0.2C140.2,68.7,140.2,93.9,140.2,119.1z M72.1,123.5 c18.2,0,36.4,0,54.5,0c5.3,0,8-2.7,8-8c0-22.7-0.1-45.5,0.1-68.2c0-5-3.3-8.1-8-8.1c-36.4,0.1-72.8,0-109.2,0.1 c-0.9,0-1.8,0-2.7,0.3c-3.4,0.9-5.2,3.5-5.2,7.5c0,22.9,0,45.7,0,68.6c0,0.4,0,0.8,0,1.2c0.2,2.9,2.1,5.4,4.9,6.2 c1.1,0.3,2.2,0.4,3.4,0.4C35.9,123.6,54,123.5,72.1,123.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,30.9c-1.9,0-3.6,0-5.5,0c0-2.6,0-5.1,0-7.6c0-2.6-0.7-3.2-3.2-3.2c-4.3,0-8.6,0-13,0c-2.2,0-2.9,0.8-2.9,3 c0,2.6,0,5.2,0,7.8c-1.8,0-3.6,0-5.4,0c0-3.2-0.2-6.5,0.1-9.7c0.4-3.9,3.7-6.6,7.6-6.6c4.8,0,9.6,0,14.5,0c4.3,0,7.7,3.4,7.8,7.7 C53,25.2,53,28,53,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,30.9c-1.9,0-3.6,0-5.5,0c0-2.6,0-5.1,0-7.6c0-2.6-0.7-3.2-3.2-3.2c-4.3,0-8.6,0-13,0c-2.2,0-2.9,0.8-2.9,3 c0,2.6,0,5.2,0,7.8c-1.8,0-3.6,0-5.4,0c0-3.2-0.2-6.5,0.1-9.6c0.4-3.9,3.7-6.6,7.6-6.6c4.8,0,9.6,0,14.5,0c4.3,0,7.7,3.4,7.8,7.7 C121.2,25.2,121.1,28,121.1,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2,85.5c0-2.8,0-5.4,0-8.1c3.6,0,7.1,0,10.9,0c0-3.7,0-7.3,0-10.9c2.8,0,5.4,0,8.1,0c0,3.6,0,7.1,0,10.8 c3.7,0,7.3,0,10.9,0c0,2.8,0,5.4,0,8.1c-3.6,0-7.1,0-10.8,0c0,3.7,0,7.3,0,10.9c-2.8,0-5.4,0-8.1,0c0-3.6,0-7.1,0-10.9 C98.4,85.5,94.8,85.5,91.2,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,77.4c10,0,19.9,0,29.8,0c0,2.7,0,5.3,0,8c-9.9,0-19.8,0-29.8,0C23.1,82.8,23.1,80.2,23.1,77.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBateriaIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bateria_icon.03e9c34b.svg";
export { ForwardRef as ReactComponent };